import {
    /** FETCH APPLICATION  */
    FETCH_ADDNOTE_FULFILLED,
    FETCH_ADDNOTE_REJECTED,
    FETCH_ADDNOTE_PENDING,
    RESET_ADDNOTE
} from "../../actions/v3/addNote";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ADDNOTE_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_ADDNOTE_FULFILLED:
            return {
                ...state,
                addNote: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_ADDNOTE_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_ADDNOTE:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};